import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="admin-footer">
      <span className="admin-footer-text">
    © Copyright 2026 Appliance Repair | Designed & Hosted By Web Universals.
      </span>
    </footer>
  );
};

export default Footer;
